export default {
  activeCurrency: null,
  currencies: [],
  loadingCurrencies: false,
  rateCache: {},
  subunitPreferences: {}
}
